goog.module('yext.storm.common.TopLevelFolders');

/**
 * initialize toplevelfolders json
 */
function init(params) {
  const topLevelFolders = [];
  const folders = params['folders'];
  folders.forEach(function(folder) {
    topLevelFolders.push(folder);
  });
  const topLevelLocation = params['topLevelLocation'];
  if (topLevelLocation) {
    topLevelFolders.push(topLevelLocation);
  }
  window.topLevelFolders = topLevelFolders;
}

exports = {
  init,
};
